import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Set title based on current route
    switch (location.pathname) {
      case '/':
      case '/validlogin':
        document.title = 'Validate User Login';
        break;
      case '/validationpage':
        document.title = 'Validate User';
        break;
      case '/paymentportal':
        document.title = 'Payments Portal';
        break;
      case '/landingprofile':
        document.title = 'My Profile Page';
        break;
      case '/employeecontract':
        document.title = 'Employee Contract';
        break;
      case '/extrawork':
        document.title = 'Extra Work Form';
        break;
      case '/snldatabaseform':
        document.title = 'SNL Database Form';
        break;
      case '/documentforms':
        document.title = 'SNL Database Documents';
        break;
      case '/calendaradminmobile':
        document.title = 'Admin Calendars';
        break;
      case '/trainingpage':
        document.title = 'Training';
        break;
      case '/supervisorfiltersd':
        document.title = 'Supervisors Data';
        break;
      case '/iglufiltersd':
        document.title = 'Iglu Data';
        break;
      case '/clientfiltersd':
        document.title = 'Client Data';
        break;
      case '/igluaddsm':
        document.title = 'Iglu Mobile Data';
        break;
      case '/adminfiltersd':
        document.title = 'Admin Data';
        break;
      case '/adminfiltersd2':
        document.title = 'Admin Data';
        break;
      case '/adminfiltersd4':
        document.title = 'Admin Data';
        break;
      case '/adminfiltersd3':
        document.title = 'Management Data';
        break;
      case '/itworkloadd':
        document.title = 'IT Data';
        break;
      case '/superleaveaddsm':
        document.title = 'Leave Data';
        break;
      case '/superrecruitsm':
        document.title = 'Recruit Data';
        break;
      case '/testntagadminmobile':
        document.title = 'Compliance Data';
        break;
      case '/superclientaddsm':
        document.title = 'Client Data';
        break;
      case '/clientaddsm':
        document.title = 'Client Mobile Data';
        break;
      case '/staffaddsm':
        document.title = 'Supervisors Data';
        break;
      case '/superonboardd':
        document.title = 'On-Boarding';
        break;
      case '/personalonboardm':
        document.title = 'Personal Data';
        break;
      case '/workavailabilitym':
        document.title = 'Casuals Available';
        break;
      case '/workavailabilityd':
        document.title = 'Casuals Available';
        break;
      case '/superworkavailabilitym':
        document.title = 'Casuals Responses';
        break;
      case '/superworkavailabilityd':
        document.title = 'Casuals Responses';
        break;
      
      
      default:
        document.title = 'Validate User';
    }
  }, [location]);

  return null;
};

export default TitleHandler;
